// @flow
import {Rox} from 'rox-ssr';

import {RELEASE_VERSION} from 'constants/app';

type HeadersType = {[string]: string};

type DataSegmentationType = {
    IP: string,
};

/**
 * Provides collecting and setting data for rollout
 */
export class DataSegmentation {
    data: DataSegmentationType;

    /**
     * Getting state and country from akamai cookie
     */
    constructor() {
        Rox.setCustomStringProperty('release', RELEASE_VERSION);

        this.data = {
            IP: '',
        };
    }

    /**
     * Checks fullfilled data to collect it again
     * @returns {boolean} - flag
     */
    isDataFulfilled = (): boolean => this.data.IP !== '';

    /**
     * Collecting data from responce, cookies and deviceDetect
     * @param {HeadersType} headers - from response
     */
    collectData = (headers: HeadersType) => {
        this.data = {
            ...this.data,
            IP: (headers['x-real-ip'] || '').split(',')[0],
        };
        if (this.isDataFulfilled()) {
            Rox.setCustomStringProperty('IP', this.data.IP);
        }
    };
}

export const dataSegmentationInstance = new DataSegmentation();
